import { create } from 'zustand';

interface IntercomState {
  isOpen: boolean;
  unreadCount: number;
  setIsOpen: (open: boolean) => void;
  setUnreadCount: (count: number) => void;
}

export const useIntercomState = create<IntercomState>((set) => ({
  isOpen: false,
  unreadCount: 0,
  setIsOpen: (open) => set({ isOpen: open }),
  setUnreadCount: (count) => set({ unreadCount: count }),
}));
